// extracted by mini-css-extract-plugin
export default {"textFieldContainer":"ASYeF","label":"fW5av"};